import { useEffect } from 'react';
import { sessionStorageController } from '../services/storages';
import type { Parkinglot } from '@autopass-web/types';

export const useParkinglotMetadataSaveStorage = (
  parkinglot: Parkinglot | null,
) => {
  useEffect(() => {
    if (parkinglot == null) return;
    sessionStorageController.saveParkinglot(parkinglot);
  }, [parkinglot]);
};
